// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"slider_sliderContainer__2jLyi","icon":"slider_icon__1F-zK","slider":"slider_slider__inpiv","disabled":"slider_disabled__XMvV7","thumb":"slider_thumb__EO0Xx"};